module.exports = __webpack_public_path__ + "static/walmart-549697757591c1d59b3cf414af876d2d.jpg";